import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../Admin1/Pages/admin1.css';
import heloicon from '../../../safreeimg/superadminimg/heloicon.png';
import axios from 'axios';
import Loader from '../../../safreeimg/loader.gif';
import leftarrow from '../../../safreeimg/left-arrow.png';

const CouponSendOrg = () => {
    const [organizations, setOrganizations] = useState([]); // Renamed to organizations
    const [selectedOrgs, setSelectedOrgs] = useState([]); // Renamed to selectedOrgs
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const couponId = window.location.hash.substring(1);

    const rowsPerPage = 10;
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const token = localStorage.getItem('token');
                if (!token) {
                    setError('No authentication token found');
                    setLoading(false);
                    return;
                }

                const response = await axios.get('https://api.safree.org/api-v2022/superAdmin/auth/v1/expired-plan/organizations', {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (response.data.success) {
                    setOrganizations(response.data.data); // Updated data handling for organizations
                } else {
                    setError('Failed to fetch organizations');
                }
            } catch (err) {
                console.error('Error fetching organizations:', err);
                setError('An error occurred while fetching organizations: ' + err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const filteredOrgs = organizations.filter((org) =>
        org.name && org.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const totalPages = Math.ceil(filteredOrgs.length / rowsPerPage);
    const currentRows = filteredOrgs.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const handlePageChange = (direction) => {
        if (direction === 'prev' && currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
        if (direction === 'next' && currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const getPageNumbers = () => {
        const maxPageNumbersToShow = 5;
        const startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
        const endPage = Math.min(totalPages, startPage + maxPageNumbersToShow - 1);

        const pageNumbers = [];
        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(i);
        }
        return pageNumbers;
    };

    const handleSelectOrg = (orgId) => {
        setSelectedOrgs((prevSelected) => {
            if (prevSelected.includes(orgId)) {
                return prevSelected.filter((id) => id !== orgId);
            } else {
                return [...prevSelected, orgId];
            }
        });
    };

    const handleSelectAll = () => {
        if (selectedOrgs.length === filteredOrgs.length) {
            setSelectedOrgs([]); // Deselect all
        } else {
            setSelectedOrgs(filteredOrgs.map((org) => org.orgId)); // Select all
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (selectedOrgs.length === 0) {
            alert('Please select at least one organization.');
            return;
        }

        try {
            setIsSubmitting(true);
            const token = localStorage.getItem('token');
            if (!token) {
                alert('No authentication token found');
                return;
            }

            const response = await axios.post(
                'https://api.safree.org/api-v2022/superAdmin/auth/v1/send/coupon/notification',
                {
                    orgIds: selectedOrgs, // Changed to orgIds
                    couponId: couponId,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data.success) {
                setSelectedOrgs([]); // Clear selected organizations after submission
                alert('Coupon sent successfully!');
            } else {
                alert('Failed to send Coupon');
            }
        } catch (err) {
            console.error('Error sending Coupon:', err);
            alert('An error occurred while sending Coupon: ' + err.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    if (loading) return <div className='loading'><img src={Loader} alt="" /></div>;
    if (error) return <div>Error: {error}</div>;

    const handleBackClick = () => {
        navigate(-1);
    };

    return (
        <div className="container user-management">
            <div className="row header">
                <div className="col-md-12">
                    <p className="sub-heading"><img onClick={handleBackClick} className="back-button" src={leftarrow} alt="" /> Send Coupon & Discount</p>
                </div>
            </div>

            <div className="row">
                <div className="col-md-12">
                    <div className="form-group clgpfom">
                        <input
                            type="text"
                            id="search"
                            className="form-control"
                            placeholder="Search by organization name"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>

                    <div className="table-container tblmnual">
                        <table className="styled-table">
                            <thead>
                                <tr>
                                    <th>
                                        <input
                                            type="checkbox"
                                            checked={selectedOrgs.length === filteredOrgs.length}
                                            onChange={handleSelectAll}
                                        />
                                    </th>
                                    <th>S. No</th>
                                    <th>Organization Name</th>
                                    <th>Email</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentRows.map((org, index) => (
                                    <tr key={org.orgId}>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={selectedOrgs.includes(org.orgId)}
                                                onChange={() => handleSelectOrg(org.orgId)}
                                            />
                                        </td>
                                        <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                                        <td>{org.name}</td>
                                        <td>{org.email}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        <div className="pagination-container">
                            <button
                                className="pagination-btn"
                                onClick={() => handlePageChange('prev')}
                                disabled={currentPage === 1}
                            >
                                &laquo; Prev
                            </button>
                            {getPageNumbers().map((page) => (
                                <button
                                    key={page}
                                    className={`pagination-btn ${currentPage === page ? 'active' : ''}`}
                                    onClick={() => setCurrentPage(page)}
                                >
                                    {page}
                                </button>
                            ))}
                            <button
                                className="pagination-btn"
                                onClick={() => handlePageChange('next')}
                                disabled={currentPage === totalPages}
                            >
                                Next &raquo;
                            </button>
                        </div>
                    </div>
                    <form className='onsub nsub' onSubmit={handleSubmit}>
                        <button type="submit" className="btn btn-submits">
                            {isSubmitting ? (
                                <div className="spinner-border text-light" style={{ width: '20px', height: '20px' }} role="status"></div>
                            ) : (
                                'Send Coupon'
                            )}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CouponSendOrg;
